import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { BulkAction, ModalService } from '@vendure/admin-ui/core';
import { unique } from '@vendure/common/lib/unique';

import { AssignCustomerToShoppingListDialogComponent } from '../components/assign-customer-to-shopping-list-dialog/assign-customer-to-shopping-list-dialog.component';
import { AssignProductsToShoppingListDialogComponent } from '../components/assign-products-to-shopping-list-dialog/assign-products-to-shopping-list-dialog.component';

export const productListBulkAction: BulkAction<any, any> = {
    location: 'product-variant-list',
    label: _('shopping-list.product-list.button-label'),
    icon: 'checkbox-list',
    requiresPermission: (userPermissions) =>
        userPermissions.includes('UpdateShoppingList'),
    onClick: ({ injector, selection, clearSelection }) => {
        const modalService = injector.get(ModalService);
        modalService
            .fromComponent(AssignProductsToShoppingListDialogComponent, {
                size: 'xl',
                locals: {
                    productVariantsIds: unique(selection.map((p) => p.id)),
                },
            })
            .subscribe((result) => {
                if (result) {
                    clearSelection();
                }
            });
    },
};

export const customerListBulkAction: BulkAction<any, any> = {
    location: 'customer-list',
    label: _('shopping-list.product-list.button-label'),
    icon: 'checkbox-list',
    requiresPermission: (userPermissions) =>
        userPermissions.includes('UpdateShoppingList'),
    onClick: ({ injector, selection, clearSelection }) => {
        const modalService = injector.get(ModalService);
        modalService
            .fromComponent(AssignCustomerToShoppingListDialogComponent, {
                size: 'xl',
                locals: {
                    customerIds: unique(selection.map((p) => p.id)),
                },
            })
            .subscribe((result) => {
                if (result) {
                    clearSelection();
                }
            });
    },
};
